<template>
  <footer>
    <div class="container-fluid">
      <span class="company">© COMSTREAM AB {{ currentYear }}</span>
      <ul class="list-inline">
        <li class="list-inline-item">
          <router-link target="_blank" :to="{ name: 'integrity' }">INTEGRITY POLICY</router-link>
          <div></div>
        </li>
        <li class="list-inline-item">
          <span @click="showCookieSettings">MANAGE COOKIES</span>
          <div></div>
        </li>
      </ul>
      <div class="social">
        FOLLOW US:
        <a href="https://www.facebook.com/jobshark" target="_blank">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="FB logo">
              <path
                id="Vector"
                d="M15.9661 1.87626C16.0078 1.34007 15.9992 0.591314 15.9992 0.0463302C15.9992 0.0463302 13.3339 0.0349686 12.8024 0.0133452C11.7295 -0.0306347 10.6414 0.0483459 9.57377 0.0463302C8.81567 0.0448642 8.0693 0.0677703 7.30276 0.0463302C6.81825 0.0325864 0.179674 0.11285 0.179674 0.11285C0.166113 0.587466 0.228235 5.53044 0.182789 6.68766C0.132762 7.96216 0.235931 12.7911 0.215957 13.891C0.204596 14.5199 0.279545 15.0063 0.201114 15.6716L0.215957 15.963C2.6682 15.963 5.21097 16.0138 7.71379 15.9964C7.70316 15.0127 7.75118 14.0011 7.70866 12.7039C7.69987 12.4375 7.69089 9.63119 7.65992 9.48349C7.65992 9.48349 6.47448 9.49174 5.93389 9.49486C5.93389 9.49486 5.89761 8.45913 5.89761 8.10912C5.89761 7.76498 5.89761 7.42121 5.89761 7.07706C5.89761 7.07706 7.27638 7.0023 7.66395 6.9684C7.66395 6.9684 7.71801 5.65486 7.77188 5.22918C7.83345 4.74301 7.84683 4.25191 8.13252 3.82145C8.65551 3.0344 9.17521 2.34061 10.1369 2.13116C10.5005 2.052 12.9009 1.58031 12.9901 1.96807L12.9362 4.30413C12.2839 4.30413 11.5028 4.23761 10.8373 4.73239C10.4666 5.00818 10.3649 5.23797 10.3271 5.69096C10.3051 5.95484 10.2998 7.02245 10.2998 7.02245C10.6513 7.07285 11.1715 7.05067 11.5492 7.02245C11.9762 6.99075 13.0716 7.104 13.0716 7.104C13.0716 7.81043 13.0434 9.44226 13.046 9.51171C12.6097 9.50457 12.2109 9.5174 11.7039 9.49541C11.6216 9.49156 10.3011 9.51135 10.3049 9.53517C10.4008 10.1227 10.263 10.7464 10.2712 11.3404C10.276 11.6865 10.3779 14.8177 10.3311 15.9722C10.915 15.9672 11.5006 15.963 12.0964 15.963C12.7991 15.963 15.2736 15.9634 15.9736 15.963C15.9736 15.963 15.8569 3.28252 15.9661 1.87626Z"
                fill="#F7F5F4"
              />
            </g>
          </svg>
        </a>

        <a href="https://www.linkedin.com/company/jobshark " target="_blank">
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="linkedIn logo" clip-path="url(#clip0_3899_5047)">
              <path
                id="Vector"
                d="M0.168945 0V16H16.1689V0H0.168945ZM5.50228 12.6667H3.50228V5.33333H5.50228V12.6667ZM4.50228 4.488C3.85828 4.488 3.33561 3.96133 3.33561 3.312C3.33561 2.66267 3.85828 2.136 4.50228 2.136C5.14628 2.136 5.66895 2.66267 5.66895 3.312C5.66895 3.96133 5.14695 4.488 4.50228 4.488ZM13.5023 12.6667H11.5023V8.93067C11.5023 6.68533 8.83561 6.85533 8.83561 8.93067V12.6667H6.83561V5.33333H8.83561V6.51C9.76695 4.786 13.5023 4.65867 13.5023 8.16067V12.6667Z"
                fill="#F7F5F4"
              />
            </g>
            <defs>
              <clipPath id="clip0_3899_5047">
                <rect width="16" height="16" fill="white" transform="translate(0.168945)" />
              </clipPath>
            </defs>
          </svg>
        </a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data: () => ({
    currentYear: new Date().getFullYear(),
  }),
  methods: {
    showCookieSettings() {
      if (typeof cookiefirst_show_settings === 'function') {
        cookiefirst_show_settings();
      } else {
        console.warn('CookieFirst function is not available');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
footer {
  font-size: 12px;
  color: #f7f5f4;
  background: #000;
  padding: 24px 94px;
  width: 100%;
  .container-fluid {
    display: flex;
  }
  span {
    display: inline-block;
    margin-right: 64px;
  }
  .list-inline {
    margin: 0;
    align-items: center;
    li {
      position: relative;
      padding-right: 20px;
      margin-right: 20px;
      a {
        text-decoration: none;
        color: #fff;
      }
      div {
        display: none;
      }
      &:after {
        content: ' ';
        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        height: 100%;
        background: #f7f5f4;
      }
      &:last-of-type {
        &:after {
          display: none;
        }
      }
      span {
        cursor: pointer;
      }
    }
  }
  .social {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
  }
}

@media (max-width: 768px) {
  footer {
    padding: 24px 12px;
    .company {
      display: none;
    }
    .list-inline {
      li {
        display: block;
        margin-bottom: 24px;
        &:after {
          display: none;
        }
        div {
          margin-top: 16px;
          display: block;
          width: 20px;
          height: 2px;
          background: #f05c00;
        }
      }
    }
  }
}
</style>
